import { render, staticRenderFns } from "./DuwaOtherInformation.vue?vue&type=template&id=0c95602b"
import script from "./DuwaOtherInformation.vue?vue&type=script&lang=js"
export * from "./DuwaOtherInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports